/**
 * Button styling shared by every auth step. The design system exposes these as
 * semantic fill tokens, so both variants stay in sync with the palette.
 */
export const AUTH_BUTTON_BASE =
  "h-auto min-h-14 w-full rounded-xl px-8 py-4 font-medium text-base";

export const AUTH_PRIMARY_BUTTON = `${AUTH_BUTTON_BASE} bg-background-fill-brand-yellow text-text hover:bg-background-fill-brand-yellow-hover active:bg-background-fill-brand-yellow-pressed`;

export const AUTH_SECONDARY_BUTTON = `${AUTH_BUTTON_BASE} gap-2 border border-brand-green2-300 bg-background-fill-primary text-text hover:bg-background-fill-primary-hover`;
